import React, {useState} from "react";
import axios from "axios";
import {NavLink} from "react-router-dom";
import * as config from "../../configs/Config";
import AuthShell, {AuthButton, AuthError, AuthInput, AuthLabel} from "./AuthShell";

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        if (!email) return setError('Enter your email first');
        setBusy(true);
        try {
            await axios.post(`${config.API_URL}/forgot-password`, {email}, {headers: {Accept: 'application/json'}});
            setSent(true);
        } catch (err) {
            setError(err.response?.data?.message || err.message);
            setBusy(false);
        }
    };

    return (
        <AuthShell>
            <h1 className="font-heading mt-5 text-center text-[26px] font-bold tracking-[-0.015em]">Reset your password</h1>
            {sent ? (
                <>
                    <p className="mt-4 text-center text-[13.5px] leading-relaxed text-white/60">
                        If that account exists, a reset link is on its way to<br/>
                        <span className="font-bold text-white">{email}</span>.<br/>
                        The link expires in 60 minutes.
                    </p>
                    <p className="mt-6 text-center text-[13px] text-white/40">
                        <NavLink to="/login" className="font-bold text-white hover:text-apple-red">Back to login</NavLink>
                    </p>
                </>
            ) : (
                <>
                    <p className="mb-6 mt-1 text-center text-[13px] text-white/40">
                        We'll email you a link to set a new one.
                    </p>
                    <AuthLabel htmlFor="fp-email">Email</AuthLabel>
                    <AuthInput id="fp-email" type="email" placeholder="you@email.com"
                               onChange={e => { setError(null); setEmail(e.target.value); }}/>
                    <AuthButton onClick={submit} disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</AuthButton>
                    <AuthError error={error}/>
                    <p className="mt-5 text-center text-[13px] text-white/40">
                        <NavLink to="/login" className="font-bold text-white hover:text-apple-red">Back to login</NavLink>
                    </p>
                </>
            )}
        </AuthShell>
    );
}
